<ng-container *ngIf="hasPaidItems">
  <div class="payment-status-section p-3 gap-3 d-flex flex-column">
    <div class="collection-details">
      <div class="d-flex flex-column gap-3" *ngIf="hasPaidLineItems()">
        <span class="collection-details-heading col-6">Collection Details:</span>
        <div class="table-responsive d-none d-sm-block">
          <table class="table" aria-label="Collection Details">
            <thead>
            <tr>
              <th *ngIf="hasTransactionReference()" scope="col">Transaction Reference</th>
              <th scope="col">Payment Method</th>
              <th scope="col">Payment Date & Time</th>
              <th scope="col">Amount</th>
            </tr>
            </thead>
            <tbody>
            <ng-container>
              <tr *ngFor="let item of pacDetails.paidLineItems">
                <td *ngIf="hasTransactionReference()"> {{ item.transactionId }} </td>
                <td>{{getPaymentMode(item.paymentMode)}}</td>
                <td>{{(item.collectionDate || today) | date: 'dd-MM-yyyy HH:mm'}}</td>
                <td>{{showAmountFormatted(item.paymentAmount)}}</td>
              </tr>
            </ng-container>
            </tbody>
          </table>
        </div>

        <div class="table-mobile-container d-flex flex-column gap-2 d-block d-sm-none">
          <ng-container>
            <div class="row-mobile d-flex align-items-center">
              <div class="info-container d-flex flex-column gap-1">
                <div *ngFor="let item of pacDetails.paidLineItems">
                  <div>
                    <span *ngIf="hasTransactionReference()" class="reference">{{ item.transactionId }}</span>
                    <span class="method">{{ getPaymentMode(item.paymentMode) }}</span>
                  </div>
                  <span class="amount"> {{ showAmountFormatted(item.paymentAmount) }}</span>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-container>
